import { useCallback } from 'react';

import { builderDispatch, PrismUI } from '../../_utils/ui';
import LoaderAdditionalOptions from '../../_photo-loader/additional-options';
import { usePrintsConfigStore } from '../stores';
import { useAvailableSizesForSelectedDeliveryAndFinish } from '../hooks/use-available-sizes-for-selected-delivery-and-finish';

/**
 * Custom hook to encapsulate the logic for triggering the photo upload loader.
 * It constructs the necessary additionalOptions and dispatches the event.
 */
export const useAddPhotos = () => {
  const { urls } = usePrintsConfigStore((state) => ({
    urls: state.urls,
  }));
  const { getPrintSizeKeyForNewUpload } = usePrintsConfigStore((state) => ({
    getPrintSizeKeyForNewUpload: state.getters.getPrintSizeKeyForNewUpload,
  }));

  const availableSizes = useAvailableSizesForSelectedDeliveryAndFinish();

  const addPhotos = useCallback(() => {
    const additionalOptions = {
      [LoaderAdditionalOptions.EXTRA_FILE_TYPES]: ['webp'],
      [LoaderAdditionalOptions.PRINT_SIZES]: availableSizes.map((size) => ({
        key: size.key,
        title: size.title,
        selected: size.key === getPrintSizeKeyForNewUpload(),
        default: size.default,
      })),
    };

    builderDispatch.dispatch({
      type: PrismUI.ADD_PHOTOS,
      // eslint-disable-next-line camelcase
      upload_url: urls.upload,
      callToActionButtonText: 'Add to prints',
      // eslint-disable-next-line camelcase
      add_title_text: 'photos will be added to your prints order',
      additionalOptions,
    });
  }, [urls.upload, availableSizes, getPrintSizeKeyForNewUpload]);

  return addPhotos;
};
